import { GetterTree } from 'vuex'
import EquipmentGuideState from '../types/EquipmentGuideState'
import RootState from '@vue-storefront/core/types/RootState'

const getters: GetterTree<EquipmentGuideState, RootState> = {
  getEquipmentGuide: state => state.equipmentGuide
}

export default getters
